import React from 'react';
import { BatchRecordIngredient } from '../../../types/batchRecordIngredient';

interface BatchRecordIngredientRowProps {
  ingredient: BatchRecordIngredient;
  onEdit: (ingredient: BatchRecordIngredient) => void;
  onDelete: (id: string, ingredientName: string) => void;
}

export const BatchRecordIngredientRow: React.FC<BatchRecordIngredientRowProps> = ({
  ingredient,
  onEdit,
  onDelete
}) => {
  const handleRowClick = (e: React.MouseEvent) => {
    // Don't trigger edit if clicking on action buttons
    if ((e.target as HTMLElement).closest('button')) {
      return;
    }
    onEdit(ingredient);
  };

  return (
    <tr
      onClick={handleRowClick}
      style={{
        borderBottom: '1px solid #e0e0e0',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#f5f5f5';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      <td
        style={{
          padding: '12px',
          fontSize: '14px',
          color: '#333'
        }}
      >
        {ingredient.rawIngredientName || 'Unknown Ingredient'}
      </td>
      <td
        style={{
          padding: '12px',
          fontSize: '14px',
          color: '#333'
        }}
      >
        {ingredient.lotNumbers && ingredient.lotNumbers.length > 0 ? (
          <span
            style={{
              padding: '2px 8px',
              backgroundColor: '#e3f2fd',
              color: '#1565c0',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '500'
            }}
          >
            {ingredient.lotNumbers[0]}
          </span>
        ) : (
          <span style={{ color: '#999', fontStyle: 'italic' }}>No lots</span>
        )}
      </td>
      <td
        style={{
          padding: '12px',
          fontSize: '14px',
          color: '#333'
        }}
      >
        {ingredient.quantity != null ? ingredient.quantity : (
          <span style={{ color: '#999', fontStyle: 'italic' }}>Not recorded</span>
        )}
      </td>
      <td
        style={{
          padding: '12px',
          fontSize: '14px',
          color: '#333'
        }}
      >
        {ingredient.unit ? ingredient.unit : (
          <span style={{ color: '#999', fontStyle: 'italic' }}>—</span>
        )}
      </td>
      <td
        style={{
          padding: '12px',
          textAlign: 'center'
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(ingredient);
          }}
          style={{
            padding: '6px 12px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px',
            marginRight: '4px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#1976D2';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#2196F3';
          }}
        >
          Edit
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(ingredient.id, ingredient.rawIngredientName || 'this ingredient');
          }}
          style={{
            padding: '6px 12px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#d32f2f';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f44336';
          }}
        >
          Delete
        </button>
      </td>
    </tr>
  );
};
